import React from "react";
const EvenOdd = ({
  eventDetails,
  evenodddata,
  setBetSlipDetails,
  getBetPlaceEvenOddList,
  onChildRuleShow,
  LoginUserId
}) => {
  //console.log("evenodddata->", evenodddata);

  const showRules = () => {
    onChildRuleShow();
  };

  const showBetSlip = (betType, teamName, sid, rate, price) => {
    setBetSlipDetails({
      bet_type: betType,
      runnername: teamName,
      sid: sid,
      odds: rate,
      amount: 0,
      price: price,
      market_type: "evenodd",
      marketid: sid
    });
  };

  if (getBetPlaceEvenOddList !== null && getBetPlaceEvenOddList.length > 0) {
    //console.log("getBetPlaceEvenOddList->", getBetPlaceEvenOddList);
  }

  const getEvenOddBook = (marketid) => {
    let returnArr = "";
    if (getBetPlaceEvenOddList !== null && getBetPlaceEvenOddList.length > 0) {
      for (let i = 0; i < getBetPlaceEvenOddList.length; i++) {
        let obj = getBetPlaceEvenOddList[i];
        let key = obj.key;
        let date_time = obj?.date_time;

        let userKey = marketid + "_" + LoginUserId;

        if (key !== undefined && key !== null && key === userKey) {
          let values = obj.value;
          if (
            values !== null &&
            values !== undefined &&
            values[0]?.user_id == LoginUserId
          ) {
            let bak = values[0]?.bak;
            let lay = values[0]?.lay;
            returnArr = (
              <span>
                {bak >= 0 ? (
                  <span
                    style={{
                      color: "green",
                      fontWeight: "bold",
                      paddingLeft: "0px",
                      fontSize: "15px"
                    }}
                  >
                    {bak}
                  </span>
                ) : (
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      paddingLeft: "0px",
                      fontSize: "15px"
                    }}
                  >
                    {bak}
                  </span>
                )}

                {lay >= 0 ? (
                  <span
                    style={{
                      color: "green",
                      fontWeight: "bold",
                      paddingLeft: "5px",
                      fontSize: "15px"
                    }}
                  >
                    {lay}
                  </span>
                ) : (
                  <span
                    style={{
                      color: "red",
                      fontWeight: "bold",
                      paddingLeft: "5px",
                      fontSize: "15px"
                    }}
                  >
                    {lay}
                  </span>
                )}
              </span>
            );
          }
        }
      }
    }

    return returnArr;
  };

  return (
    <div style={{ display: "block" }}>
      <div className="table-box-body">
        <div className="tb-content">
          <div className="market-titlebar">
            <p className="market-name">
              <span className="market-name-badge">
                <i className="market-name-icon">
                  <img
                    src="/assets/images/time-img.png"
                    style={{
                      filter: "invert(100%)",
                      marginTop: "-8px",
                      marginLeft: "-1px"
                    }}
                  />
                </i>
                <span>
                  Even/Odd{" "}
                  <span style={{ textTransform: "initial" }}>
                    (MaxBet: 200K)
                  </span>
                </span>{" "}
                <span style={{ textTransform: "initial" }}></span>
              </span>
              <span className="rules-badge" onClick={() => showRules()}>
                <i className="fa fa-info-circle"></i>
              </span>
            </p>
            <div className="market-overarround">
              <span></span>
              <strong>BACK</strong>
            </div>
            <div className="market-overarround market-overarround-lay">
              <strong>LAY</strong>
            </div>
          </div>
          <div className="market-runners">
            {evenodddata !== null &&
              evenodddata !== undefined &&
              evenodddata !== "" &&
              evenodddata.map((fancy) => (
                <div className="runner-runner">
                  <h3 className="runner-name">
                    <div className="runner-info">
                      <span className="clippable runner-display-name">
                        <table>
                          <tr>
                            <td>
                              <h4
                                className="clippable-spacer"
                                style={{
                                  fontWeight: "normal",
                                  textTransform: "capitalize",
                                  wordWrap: "break-word",
                                  whiteSpace: "break-spaces",
                                  lineHeight: "20px",
                                  fontSize: "15px",
                                  fontWeight: "600"
                                }}
                              >
                                {fancy.market}
                              </h4>
                            </td>
                          </tr>
                          <tr>
                            <td> {getEvenOddBook(fancy.marketid)}</td>
                          </tr>
                        </table>
                      </span>
                    </div>
                  </h3>

                  <div className="price-row-box-new">
                    <a
                      className="price-price price-lay"
                      style={{ background: "#e8f6fc" }}
                    >
                      &nbsp;
                    </a>
                    <a
                      className="price-price price-lay mr-4"
                      style={{ background: "#e8f6fc" }}
                    >
                      &nbsp;
                    </a>

                    <a
                      onClick={() =>
                        showBetSlip(
                          "b",
                          fancy.market,
                          fancy.marketid,
                          fancy.back,
                          fancy.backrate
                        )
                      }
                      className="price-price price-back mb-show"
                      style={{
                        backgroundColor: "rgb(141, 210, 240)",
                        textDecoration: "none",
                        color: "black"
                      }}
                    >
                      <div>
                        <span className="price-odd">{fancy.back}</span>
                        <span className="price-amount">{fancy.backrate}</span>
                      </div>
                    </a>
                    <a
                      className="price-price price-lay mb-show ml-4"
                      style={{
                        backgroundColor: "rgb(254, 175, 178)",
                        textDecoration: "none",
                        color: "black"
                      }}
                      onClick={() =>
                        showBetSlip(
                          "l",
                          fancy.market,
                          fancy.marketid,
                          fancy.lay,
                          fancy.layrate
                        )
                      }
                    >
                      <div>
                        <span className="price-odd">{fancy.lay}</span>
                        <span className="price-amount">{fancy.layrate}</span>
                      </div>
                    </a>
                    <a
                      className="price-price price-back"
                      style={{ background: "#fce3e4" }}
                    >
                      &nbsp;
                    </a>
                    <a
                      className="price-price price-back"
                      style={{ background: "#fce3e4" }}
                    >
                      &nbsp;
                    </a>

                    <div
                      className="suspended-overlap"
                      style={{ display: fancy.status === "OPEN" ? "none" : "" }}
                    >
                      Suspended
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default EvenOdd;